import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import SliderComponent from './sliderComponent.js'
import { priceDefault } from "../price/priceFilterConfig"
import { buildPriceLabel } from "../price/priceFilterConfig"

class PriceInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentRange : this.props.currentRange,
            labelRange : this.props.currentRange,
        }
    }

    componentDidMount() {
        //we might grab the URL here on mount. but I don't know if we should or not. 
        //might pass these down as defaultValue props.

    }

    componentDidUpdate(prevProps) {
        //console.log('prev', prevProps)
        //console.log('new', this.props)
        if(prevProps.currentRange !== this.props.currentRange) {
           // console.log('not equal')
            if(this.props.currentRange !== this.state.currentRange) {
               // console.log('not equal 2')
                this.setState({ currentRange : this.props.currentRange, labelRange : this.props.currentRange })

            }

        }

    }
    

    handleLabelChange = (values) => {
        this.setState({
            labelRange : values
        })
    }


    handlePriceChange = (values) => {
        this.setState({
            currentRange : values
        })
        this.props.onChange(values)
    }

    render() {

        const { 
            currentRange,
            labelRange

        } = this.state

        const { 
            showFeedbackLabel,
            defaultMin,
            defaultMax
        } = this.props


    return (

        <React.Fragment>
            {showFeedbackLabel && (
            <div className="slider-label">
                {buildPriceLabel('long', labelRange, [defaultMin, defaultMax])}
            </div>
            )}
            <SliderComponent
                domain={[defaultMin, defaultMax]}
                currValues={currentRange}
                steps={10}
                onUpdate={this.handleLabelChange}
                onSlideEnd={this.handlePriceChange}

            />
        </React.Fragment>           
        )
    }
}
            
            
export default withRouter(PriceInput)

PriceInput.defaultProps = {
  showFeedbackLabel: true,
  defaultMin: priceDefault[0],
  defaultMax: priceDefault[1],
  defaultLabel: "Price",
  currentRange: [priceDefault[0], priceDefault[1]],
  onChange: function() {}
}